import { Translation } from '../translation';

/**
 * Search command for rolls paginated search
 */
export interface RollSearchCommand {
  rollNumbers?: string[];
  itemCodes?: string[];
  fabricCodes?: string[];
  locationCodes?: string[];
  knittingOrderReferences?: string[];
  productionCardReferences?: string[];
  dispatchInstructionReferences?: string[];
  workOrderReferences?: string[];
  clientProductOrderNumbers?: string[];
  statuses?: RollStatus[];
  categories?: RollCategory[];
  qualities?: RollQuality[];
  excludeRollNumbers?: string[];
}

/**
 * Roll status enum
 */
export enum RollStatus {
  NotInspected = 0,
  Approved = 1,
  Rejected = 2,
  OnHold = 3,
  PartiallyApproved = 4,
}

/**
 * Roll category enum
 */
export enum RollCategory {
  A = 0,
  B = 1,
  C = 2,
}

/**
 * Roll quality enum
 */
export enum RollQuality {
  First = 0,
  Second = 1,
  Third = 2,
}

export function getRollStatusLabel(status: RollStatus): Translation {
  const labels: Record<RollStatus, Translation> = {
    [RollStatus.NotInspected]: { es: 'No Inspeccionado', en: 'Not Inspected' },
    [RollStatus.Approved]: { es: 'Aprobado', en: 'Approved' },
    [RollStatus.Rejected]: { es: 'Rechazado', en: 'Rejected' },
    [RollStatus.OnHold]: { es: 'En Espera', en: 'On Hold' },
    [RollStatus.PartiallyApproved]: { es: 'Parcialmente Aprobado', en: 'Partially Approved' },
  };
  return labels[status] || { es: 'Desconocido', en: 'Unknown' };
}
